import { FC } from 'react';
import Button from 'components/Button/Button';
import { Body, Heading } from 'components/text';
import Container from 'components/container';

type IEnquire = {
  handleOpenEnquiryForm: () => void;
};

const Enquire: FC<IEnquire> = ({ handleOpenEnquiryForm }) => {
  return (
    <div className="enquire-container" id="enquire">
      <div
        className="enquire-container__image-container"
        title="Cover for learn more about the myler program"
      >
        <div className="enquire-container__message-card">
          <div>
            <Heading as="h4"> Interested in becoming a MyLER?</Heading>
            <Body mt={20} color="grey-dark">
              Just complete a short form and a member of our team will be in
              touch with more information
            </Body>
          </div>
          <Container mt={40}>
            <Button
              title={'Enquire'}
              onClick={() => handleOpenEnquiryForm()}
              className="btn"
            />
          </Container>
        </div>
      </div>
    </div>
  );
};

export default Enquire;
